/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CalendarStatusData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsCalendarStatus: build.query<CalendarStatusData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/calendar` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsCalendarStatusApi };
export const { useGetSettingsCalendarStatusQuery, useLazyGetSettingsCalendarStatusQuery } = injectedRtkApi;
